import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {DtmService} from '../services/dtm.service';
import {Dtm} from '../shared/enum/dtm';

@Component({
    selector: 'pme-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(public dtmService: DtmService) {
    this.dtmService.pageLoaded(Dtm.NotFound);
  }

  ngOnInit() {
    const hasCategory = sessionStorage.getItem('category');
    const hasPlan = sessionStorage.getItem('plan');
    let errorDetail = "";
    if (!hasCategory && !hasPlan){
      errorDetail = "Categoria e Plano não encontrado!";
    } else if (hasCategory && !hasPlan){
      errorDetail = "Plano não encontrado!";
    } else {
      errorDetail = "Categoria não encontrada!";
    }

    this.dtmService.customNotFoundError(['error'], {
      errorDetail: errorDetail,
      errorMessage: "Estamos trabalhando para resolver este problema. Por favor, tente novamente."
    });
  }
}
